import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type CsticUpdate } from "~/features/configurator/Linear/api/sendLinearConfiguratorUpdate";
import { prepareCommonRailData, sendRail } from "~/features/configurator/Rail/api/sendRailCommon";
import { prepareApiDataForUpdate } from "~/features/configurator/common/commonConfiguratorApi";

export function sendRailUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[],
): Promise<LinearConfiguration> {
  const data = prepareCommonRailData(linearState);

  const updateData = prepareApiDataForUpdate(linearState, updatedCstics);

  return sendRail({
    ...data,
    ...updateData,
  });
}
